// extracted by mini-css-extract-plugin
export var bubble = "_q-0";
export var container = "_q-f";
export var contrastBorder = "_q-g";
export var greyOut = "_q-2";
export var initialsColor0 = "_q-3";
export var initialsColor1 = "_q-4";
export var initialsColor10 = "_q-d";
export var initialsColor11 = "_q-e";
export var initialsColor2 = "_q-5";
export var initialsColor3 = "_q-6";
export var initialsColor4 = "_q-7";
export var initialsColor5 = "_q-8";
export var initialsColor6 = "_q-9";
export var initialsColor7 = "_q-a";
export var initialsColor8 = "_q-b";
export var initialsColor9 = "_q-c";
export var initialsWrapper = "_q-1";
export var large = "_q-l";
export var medium = "_q-k";
export var mediumSmall = "_q-j";
export var mediumSmallMedium = "_q-o";
export var micro = "_q-h";
export var small = "_q-i";
export var tiny = "_q-n";
export var xTiny = "_q-m";